import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class TeamForm extends React.Component {
  render() {
    return (
      <Form horizontal onSubmit={this.props.onSave}>
        <FormGroup validationState={this.props.errors && this.props.errors.name ? 'error' : null} controlId="formHorizontalName">
          <Col xs={2} componentClass={ControlLabel}>
            Name
          </Col>
          <Col xs={5}>
            <FormControl name="name" type="text" placeholder="Name" value={this.props.preset.name}
                         onChange={this.props.onChange}/>
            <FormControl.Feedback/>
            {this.props.errors.name ? <HelpBlock>{this.props.errors.name}</HelpBlock> : ''}
          </Col>
        </FormGroup>

        <FormGroup validationState={this.props.errors && this.props.errors.size ? 'error' : null} controlId="formHorizontalSize">
          <Col xs={2} componentClass={ControlLabel}>
            Size
          </Col>
          <Col xs={5}>
            <FormControl name="size" type="number" min="0" placeholder="Size" value={this.props.preset.size}
                         onChange={this.props.onChange}/>
            <FormControl.Feedback/>
            {this.props.errors.size ? <HelpBlock>{this.props.errors.size}</HelpBlock> : ''}
          </Col>
        </FormGroup>

        <FormGroup controlId="formHorizontalPurpose">
          <Col xs={2} componentClass={ControlLabel}>
            Purpose
          </Col>
          <Col xs={5}>
            <FormControl name="purpose" type="text" componentClass='textarea' placeholder="Purpose" value={this.props.preset.purpose}
                         onChange={this.props.onChange}/>
            <FormControl.Feedback/>
          </Col>
        </FormGroup>

        <FormGroup>
          <Col xs={2} componentClass={ControlLabel}>
            Product Owner
          </Col>
          <Col xs={5}>
            <Select.AsyncCreatable
              multi={false}
              value={this.props.productOwner}
              onChange={this.props.selectProductOwner}
              loadOptions={this.props.getContacts}
              labelKey="name"
              valueKey="name"
              />
          </Col>
        </FormGroup>

        <FormGroup>
          <Col xs={2} componentClass={ControlLabel}>
            Scrum Master
          </Col>
          <Col xs={5}>
            <Select.AsyncCreatable
              multi={false}
              value={this.props.scrumMaster}
              onChange={this.props.selectScrumMaster}
              loadOptions={this.props.getContacts}
              labelKey="name"
              valueKey="name"
            />
          </Col>
        </FormGroup>

        <FormGroup>
          <Col xsOffset={2} xs={5}>
            <div className='text-right'>
              <Button className='secondary' onClick={this.props.onCancel}>Cancel</Button>
              <Button data-cy="save-team" className='primary ml1' type="submit">Save</Button>
            </div>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

TeamForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  preset: PropTypes.object,
  errors: PropTypes.object,
  getContacts: PropTypes.func,
  selectProductOwner: PropTypes.func,
  selectScrumMaster: PropTypes.func,
};

export default TeamForm;


// WEBPACK FOOTER //
// ./src/components/teams/TeamForm.js